import { VOLUME_TIERS } from 'src/components/Modals/FeeTierModal/consts';

/**
 * The rung to point the user at next, or `undefined` when there is none left.
 *
 * The rung worth chasing is the first one above the tier the user is *charged*
 * at, not the one above the tier their volume earns. While a promo floors them
 * above their own rung, the next volume rung can be one they are already
 * beating, so reaching it would buy them nothing and the rung after it is the
 * real target. Once the charged tier is the top of the ladder there is nothing
 * left to chase at all.
 *
 * @param userVolumeTierIndex Rung the 30D volume earns, `-1` when unknown.
 * @param userFeeTierIndex Rung actually charged, `-1` when unknown.
 */
export default function getNextVolumeTierIndex(
	userVolumeTierIndex: number,
	userFeeTierIndex: number
): number | undefined {
	// An unknown tier reads as below the entry tier, and the rung above "no
	// tier" is the one above the entry tier rather than the entry tier itself.
	const reachedIndex = Math.max(userVolumeTierIndex, userFeeTierIndex, 0);
	const nextIndex = reachedIndex + 1;

	return nextIndex < VOLUME_TIERS.length ? nextIndex : undefined;
}
